import { createRouter, createWebHashHistory } from "vue-router";
import Login from "../views/login/index.vue";
import Exam from "../views/exam/index.vue";
import Rule from "../views/login/rule.vue";
import Finish from "../views/login/examFinish.vue";
import { ElMessage } from "element-plus";
import { keyDownDisable, visibilityInterval } from "@/utils";
import { useAppStoreWithOut } from "../store";
const appStore = useAppStoreWithOut();
// 启用路由
const routers = [
  {
    path: "/",
    name: "",
    component: Login,
    hidden: true,
    redirect: "/login",
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/login",
    name: "登录",
    component: Login,
    hidden: true,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/exam",
    name: "考试",
    component: Exam,
    hidden: true,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/rule",
    name: "考试规则",
    component: Rule,
    hidden: true,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/finish",
    name: "考试结束",
    component: Finish,
    hidden: true,
    meta: {
      requireAuth: false,
    },
  },
];

export const router = createRouter({
  history: createWebHashHistory(), // createWebHashHistory URL带#，createWebHistory URL不带#
  strict: true,
  routes: routers,
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

router.beforeEach((to, from, next) => {
  // 登录页 结束页  清空禁用操作
  if (to.path === "/login" || to.path === "/finish") {
    // window.removeEventListener("keydown", keyDownDisable);
    // document.removeEventListener("visibilitychange", visibilityInterval);
    clearInterval(appStore.getClock);
    next();
    return;
  } else {
    if (!localStorage.getItem("MD5")) {
      next("/login");
      return;
    }
    // // 禁用登录页以外的键盘事件
    // window.addEventListener("keydown", keyDownDisable);
    // // 监听网页离开回来后  重新倒计时
    // document.addEventListener("visibilitychange", visibilityInterval);
    next();
  }
  // if (to.path === "/login" || to.path === "/finish" || to.path === "/") {
  //   window.removeEventListener("keydown", keyDownDisable);
  //   document.removeEventListener("visibilitychange", visibilityInterval);
  //   clearInterval(appStore.getClock);
  // } else if (localStorage.getItem("MD5")) {
  //   // 禁用登录页以外的键盘事件
  //   window.addEventListener("keydown", keyDownDisable);
  //   // 监听网页离开回来后  重新倒计时
  //   document.addEventListener("visibilitychange", visibilityInterval);
  // } else {
  //   next("/login");
  //   ElMessage.error("请登录");
  // }
  // next();
});
